export const siteInfo = {
  name: '91精品影视',
  slogan: '海量高清影视资源，随时随地离线观看',
  intro: '91精品影视是国内领先的影视资源下载平台，专注为用户提供高清影视看片下载服务。平台汇聚海量影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容，支持多种清晰度选择与高速下载通道。每日更新最新影视资源，确保用户第一时间获取热门大片与经典佳作。无需注册即可免费下载，搭配专属安装包与下载工具，实现稳定离线观看体验。安全无毒、资源丰富，是千万用户信赖的影视下载首选。',
  stats: [
    { label: '每日更新', value: '200+' },
    { label: '影视资源', value: '50,000+' },
    { label: '高清画质', value: '1080P+' },
  ],
  primaryCta: { text: '立即下载', href: '#app' },
  secondaryCta: { text: '浏览资源', href: '#index' },
};

export const featuresData = [
  {
    icon: 'ri-hd-line',
    title: '超清画质',
    desc: '支持1080P至4K超高清画质下载，杜比音效加持，带来影院级观影享受。',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '极速下载',
    desc: '多节点CDN加速与P2P下载技术，峰值速度可达10MB/s，大文件也能秒下完成。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量资源',
    desc: '影视资源库超5万部，涵盖国内外电影、热播剧集、综艺动漫，每日持续增长。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无毒',
    desc: '所有资源经多重安全检测，无病毒无木马无捆绑，纯净安装包保障设备安全。',
  },
  {
    icon: 'ri-time-line',
    title: '实时更新',
    desc: '院线新片上线后24小时内同步更新，热门剧集随播随更，追剧不等待。',
  },
];

export const mediaData = [
  {
    title: '热门动作大片合集',
    desc: '2026年最值得下载的动作电影精选，高燃打斗与震撼特效，一次收藏全部。',
    tag: '动作精选',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20action%20movie%20scene%20with%20dramatic%20lighting%2C%20film%20grain%20texture%2C%20dark%20moody%20atmosphere%2C%20professional%20cinematography%20style%2C%20warm%20golden%20and%20crimson%20color%20tones%2C%20abstract%20film%20aesthetic&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '高分悬疑剧集推荐',
    desc: '烧脑反转不断，年度口碑悬疑剧合集，每一部都值得通宵刷完，下载离线慢慢品。',
    tag: '悬疑推荐',
    image: 'https://readdy.ai/api/search-image?query=mysterious%20thriller%20film%20aesthetic%20with%20shadow%20and%20light%20contrast%2C%20noir%20cinematography%20style%2C%20dark%20atmosphere%20with%20warm%20accent%20lighting%2C%20movie%20film%20strip%20texture%2C%20suspenseful%20mood&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '经典华语电影珍藏',
    desc: '回顾华语电影黄金年代，从武侠到文艺，经典之作高清修复版下载，影迷必备。',
    tag: '经典珍藏',
    image: 'https://readdy.ai/api/search-image?query=classic%20Chinese%20cinema%20aesthetic%20with%20warm%20nostalgic%20tones%2C%20vintage%20film%20texture%2C%20golden%20hour%20lighting%2C%20artistic%20composition%2C%20movie%20reel%20and%20projector%20elements%2C%20soft%20focus%20background&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '年度动画电影精选',
    desc: '国内外高分动画电影资源合集，画风精美故事动人，适合全年龄段下载收藏。',
    tag: '动画精选',
    image: 'https://readdy.ai/api/search-image?query=artistic%20animated%20film%20scene%20with%20rich%20colors%20and%20cinematic%20lighting%2C%20dreamy%20atmosphere%2C%20film%20grain%20overlay%2C%20warm%20and%20vibrant%20color%20palette%2C%20professional%20animation%20art%20style&width=800&height=500&seq=media-04&orientation=landscape',
  },
];

export const contactData = {
  title: '资源投稿与合作',
  desc: '欢迎广大影视爱好者投稿资源或提出宝贵建议。如您有优质影视资源想与大家分享，或有合作意向，请通过以下方式联系我们。投稿资源经审核通过后将标注您的贡献并上架下载专区。',
  email: 'contact@91jpys.com',
  qq: '1234567890',
};

export const carouselData = [
  {
    title: '2026暑期档观影指南',
    desc: '暑期档最受期待的20部大片已全部上线，从动作到科幻、从喜剧到动画，这个夏天让你的硬盘不再寂寞。',
    tag: '专题推荐',
    image: 'https://readdy.ai/api/search-image?query=summer%20blockbuster%20movie%20montage%20aesthetic%20with%20warm%20golden%20lighting%2C%20cinematic%20film%20frame%20borders%2C%20dramatic%20composition%2C%20movie%20poster%20collage%20style%2C%20rich%20contrast%20and%20vibrant%20colors&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '豆瓣8.5+高分影视合集',
    desc: '精选豆瓣评分8.5分以上的口碑神作，涵盖电影、纪录片与迷你剧，每一部都经得起时间考验的经典。',
    tag: '高分精选',
    image: 'https://readdy.ai/api/search-image?query=premium%20film%20collection%20aesthetic%20with%20elegant%20golden%20tones%2C%20movie%20award%20trophy%20atmosphere%2C%20cinematic%20lighting%2C%20sophisticated%20dark%20background%20with%20warm%20highlights%2C%20classic%20cinema%20style&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '日韩热门剧集下载专区',
    desc: '最新日韩剧集同步更新，从都市爱情到悬疑犯罪，每周第一时间更新最新集数，追剧党不可错过的下载宝库。',
    tag: '日韩专区',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20Korean%20drama%20cinematic%20aesthetic%20with%20soft%20romantic%20lighting%2C%20film%20strip%20border%20design%2C%20warm%20atmospheric%20tones%2C%20urban%20night%20scene%20texture%2C%20elegant%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '美剧全季资源打包下载',
    desc: '经典美剧从第一季到最终季完整资源包，HBO、Netflix等平台热门剧集一网打尽，英文原声搭配中文字幕。',
    tag: '美剧合集',
    image: 'https://readdy.ai/api/search-image?query=American%20TV%20series%20cinematic%20montage%20with%20dramatic%20lighting%2C%20film%20reel%20and%20clapperboard%20elements%2C%20dark%20atmospheric%20background%20with%20warm%20golden%20accent%2C%20professional%20production%20aesthetic&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '纪录片爱好者必下清单',
    desc: 'BBC、国家地理、Discovery等顶级制作纪录片合集，自然、历史、科技、人文四大主题全覆盖，每一帧都是壁纸级画质。',
    tag: '纪录精选',
    image: 'https://readdy.ai/api/search-image?query=documentary%20film%20aesthetic%20with%20natural%20landscape%20cinematography%2C%20warm%20earthy%20tones%2C%20film%20camera%20lens%20texture%2C%20professional%20wildlife%20and%20nature%20photography%20style%2C%20cinematic%20composition&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
];

export const faqData = [
  {
    q: '91精品影视的资源是否需要付费？',
    a: '91精品影视所有资源均为免费下载，无需注册、无需付费。我们坚持开放共享的理念，为用户提供零门槛的高清影视下载体验。部分资源可能需要使用专用下载工具，工具同样免费提供。',
  },
  {
    q: '下载的影视资源清晰度如何？支持哪些格式？',
    a: '平台资源覆盖720P、1080P、2K及4K等多种清晰度，默认为1080P高清版本。主流格式包括MP4、MKV、RMVB等，兼容手机、平板、电脑及智能电视等各类播放设备，可根据需求选择对应清晰度与格式下载。',
  },
  {
    q: '下载速度慢怎么办？有没有加速方法？',
    a: '推荐使用平台提供的专用下载工具91下载器，支持多线程下载与P2P加速技术。同时，选择离您最近的CDN节点下载也能显著提升速度。如遇高峰期拥堵，建议错峰下载或更换下载节点。',
  },
  {
    q: '如何找到自己想看的影视资源？',
    a: '您可以通过首页的分类标签、主题索引或排行榜快速定位感兴趣的资源。也可在下载专区内按类型、年份、地区、评分等条件精准筛选。平台搜索功能支持影片名、演员名、导演名等多维度检索。',
  },
  {
    q: '下载的影片播放不了怎么办？',
    a: '首先确认已安装主流播放器如PotPlayer、VLC或MX Player。如仍无法播放，请检查下载文件是否完整（对比文件大小），建议重新下载。部分影片需安装对应解码器，可在下载专区获取解码器安装包。遇到其他问题可联系客服获取技术支持。',
  },
];

export const aboutData = {
  title: '关于91精品影视',
  desc: '91精品影视创立于2020年，是国内专业的影视资源下载服务平台。平台始终坚持\"免费、高清、安全、及时\"四大原则，致力于为广大影视爱好者提供一站式的影视下载解决方案。经过数年发展，平台已积累超过5万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容，日均更新量超过200部，累计服务用户超过千万人次。我们拥有专业的内容审核团队与技术团队，确保每一部资源都经过安全检测与画质筛选，让用户下载放心、观看舒心。未来，91精品影视将持续扩大资源库规模，优化下载体验，打造国内最具影响力的影视资源下载平台。',
};

export const topicsData = [
  { name: '动作大片', count: '1,280', hot: true },
  { name: '科幻巨制', count: '856', hot: true },
  { name: '悬疑烧脑', count: '1,024', hot: false },
  { name: '喜剧搞笑', count: '932', hot: false },
  { name: '爱情文艺', count: '768', hot: false },
  { name: '恐怖惊悚', count: '645', hot: true },
  { name: '动画动漫', count: '1,150', hot: false },
  { name: '纪录片', count: '520', hot: false },
  { name: '华语经典', count: '1,890', hot: true },
  { name: '日韩热剧', count: '1,420', hot: true },
  { name: '美剧英剧', count: '1,356', hot: false },
];

export const cardsData = [
  {
    title: '《暗夜追缉》1080P高清下载',
    desc: '年度犯罪动作巨制，硬汉刑警与高智商罪犯的巅峰对决，全程高能无尿点。',
    tag: '最新上线',
    image: 'https://readdy.ai/api/search-image?query=crime%20action%20movie%20aesthetic%20with%20noir%20lighting%2C%20dark%20urban%20night%20scene%2C%20cinematic%20film%20grain%2C%20dramatic%20shadow%20contrast%2C%20warm%20streetlight%20tones&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '《时光旅人》4K修复版',
    desc: '经典科幻电影4K数字修复版本，画质全面升级，重温穿越时空的震撼与感动。',
    tag: '经典修复',
    image: 'https://readdy.ai/api/search-image?query=science%20fiction%20film%20aesthetic%20with%20warm%20golden%20light%20rays%2C%20time%20travel%20concept%20visual%2C%20cinematic%20lens%20flare%2C%20vintage%20meets%20futuristic%20style%2C%20soft%20atmospheric%20glow&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '《深海迷踪》蓝光原盘',
    desc: '深海探险题材灾难大片，IMAX摄影机拍摄，视觉震撼无与伦比，蓝光原盘完整收录。',
    tag: '蓝光原盘',
    image: 'https://readdy.ai/api/search-image?query=deep%20ocean%20adventure%20cinematic%20scene%20with%20blue%20and%20warm%20light%20contrast%2C%20underwater%20atmosphere%2C%20film%20texture%20overlay%2C%20dramatic%20lighting%2C%20mysterious%20deep%20sea%20aesthetic&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: '《笑傲江湖2026》抢先版',
    desc: '武侠喜剧全新力作，豪华演员阵容爆笑演绎江湖恩怨，院线同步抢先下载体验。',
    tag: '抢先下载',
    image: 'https://readdy.ai/api/search-image?query=wuxia%20comedy%20film%20aesthetic%20with%20warm%20sunset%20lighting%2C%20traditional%20Chinese%20costume%20elements%2C%20cinematic%20composition%2C%20golden%20hour%20outdoor%20scene%2C%20artistic%20film%20style&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '《星际边境》系列合集',
    desc: '史诗级太空科幻系列五部曲完整收录，从起源到终章，一次性下载全集痛快刷完。',
    tag: '系列合集',
    image: 'https://readdy.ai/api/search-image?query=epic%20space%20opera%20cinematic%20aesthetic%20with%20stars%20and%20nebula%20background%2C%20film%20strip%20border%2C%20dramatic%20cosmic%20lighting%2C%20scifi%20movie%20atmosphere%2C%20grand%20scale%20composition&width=600&height=400&seq=card-05&orientation=landscape',
  },
];

export const updatesData = [
  {
    date: '2026-07-31',
    title: '《暗夜追缉》1080P高清版本正式上线下载专区',
    desc: '年度犯罪动作巨制，IMDb评分8.1，提供1080P与4K双版本下载。',
  },
  {
    date: '2026-07-30',
    title: '下载工具91下载器更新至v3.2.0版本',
    desc: '新版下载器优化P2P传输效率，新增智能节点选择功能，下载速度提升30%。',
  },
  {
    date: '2026-07-28',
    title: '日韩剧集专区新增12部热播剧',
    desc: '包括《秘密森林3》《浪漫速成班2》等热门续作，全部支持中文字幕。',
  },
  {
    date: '2026-07-25',
    title: '纪录片专题\"地球脉动\"系列完整上线',
    desc: 'BBC经典纪录片系列全集4K版本，自然纪录爱好者的视觉盛宴。',
  },
  {
    date: '2026-07-22',
    title: '暑期档专题页面上线，20部大片一站下载',
    desc: '暑期档最全观影指南，从动作到科幻，从动画到喜剧，一网打尽。',
  },
  {
    date: '2026-07-20',
    title: '服务器全面升级，下载带宽扩容至10Gbps',
    desc: '为应对暑期下载高峰，平台已完成服务器扩容，下载体验更流畅。',
  },
  {
    date: '2026-07-18',
    title: '华语经典修复计划启动，首批50部4K修复版上线',
    desc: '《霸王别姬》《花样年华》等华语经典电影4K数字修复版现已开放下载。',
  },
];

export const appData = {
  title: '91精品影视下载工具',
  desc: '专属下载工具91下载器，支持Windows、macOS、Android多平台。内置高速下载引擎与智能资源匹配，让影视下载更快更稳。扫描二维码或点击下方按钮，立即获取最新版安装包。',
  features: ['多线程极速下载', '智能断点续传', '边下边播功能', '资源智能推荐'],
  qrImage: 'https://readdy.ai/api/search-image?query=minimalist%20QR%20code%20style%20pattern%20with%20warm%20dark%20tones%2C%20geometric%20abstract%20design%2C%20clean%20modern%20aesthetic%2C%20dark%20background%20with%20golden%20accents&width=300&height=300&seq=app-qr&orientation=squarish',
  ctaText: '下载安装包',
};

export const rankingData = [
  { rank: 1, title: '暗夜追缉', type: '动作 / 犯罪', hot: '本周最热', change: 'new' },
  { rank: 2, title: '时光旅人（4K修复版）', type: '科幻 / 冒险', hot: '热度飙升', change: 'up' },
  { rank: 3, title: '笑傲江湖2026', type: '喜剧 / 武侠', hot: '新片推荐', change: 'new' },
  { rank: 4, title: '秘密森林3', type: '悬疑 / 剧情', hot: '追剧首选', change: 'up' },
  { rank: 5, title: '深海迷踪', type: '灾难 / 冒险', hot: '蓝光推荐', change: 'down' },
  { rank: 6, title: '星际边境合集', type: '科幻 / 史诗', hot: '系列经典', change: 'same' },
  { rank: 7, title: '浪漫速成班2', type: '爱情 / 喜剧', hot: '话题热剧', change: 'up' },
];

export const commentsData = [
  {
    author: '电影发烧友老王',
    date: '2026-07-30',
    content: '用了91精品影视三年了，资源更新真的快，每次院线新片下映后没几天就能在这找到高清版。下载速度也一直很稳定，推荐给了身边所有喜欢看电影的朋友！',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photography%20with%20warm%20lighting%2C%20confident%20expression%2C%20clean%20dark%20background%2C%20cinematic%20portrait%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    author: '追剧小达人',
    date: '2026-07-28',
    content: '日韩剧集更新速度绝了！每周都准时蹲守更新，字幕质量也很高。下载工具用起来很方便，断点续传功能太实用了，再也不怕下载到一半断网了。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20professional%20portrait%20with%20soft%20studio%20lighting%2C%20friendly%20smile%2C%20clean%20neutral%20background%2C%20modern%20portrait%20photography%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    author: '纪录片控阿杰',
    date: '2026-07-25',
    content: '纪录片的资源太全了！BBC和国家地理的经典系列都能找到，而且很多是4K版本。最近上线的地球脉动全集画质炸裂，在大电视上看太享受了。感谢平台团队！',
    avatar: 'https://readdy.ai/api/search-image?query=mature%20man%20portrait%20with%20warm%20natural%20lighting%2C%20thoughtful%20expression%2C%20dark%20simple%20background%2C%20editorial%20portrait%20photography&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
];

export const indexData = [
  { title: '动作冒险', desc: '高燃打斗·肾上腺素飙升', icon: 'ri-fire-line', count: '1,280部' },
  { title: '科幻奇幻', desc: '未来世界·想象力无限', icon: 'ri-rocket-line', count: '856部' },
  { title: '悬疑惊悚', desc: '烧脑反转·猜不到结局', icon: 'ri-search-eye-line', count: '1,024部' },
  { title: '喜剧搞笑', desc: '轻松解压·笑到停不下来', icon: 'ri-emotion-laugh-line', count: '932部' },
  { title: '爱情文艺', desc: '浪漫动人·文艺清新', icon: 'ri-heart-line', count: '768部' },
  { title: '纪录写实', desc: '真实故事·深度思考', icon: 'ri-camera-lens-line', count: '520部' },
  { title: '动画动漫', desc: '二次元世界·全龄段享受', icon: 'ri-movie-line', count: '1,150部' },
  { title: '华语经典', desc: '光影记忆·华语宝藏', icon: 'ri-vip-crown-line', count: '1,890部' },
];

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '专题推荐', href: '#carousel' },
  { label: '主题索引', href: '#index' },
  { label: '关于91精品影视', href: '#about' },
  { label: '读者评论', href: '#comments' },
  { label: '精选合集推荐', href: '#media' },
  { label: '资源卡片', href: '#cards' },
];